// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"823":"8d5af9ff4d166732b495","847":"18108e180a574df9ef6a","950":"875f1b338c9a8e256415"}[chunkId] + ".css";
};